"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgQuestionCircleWhite = function SvgQuestionCircleWhite(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    role: "img"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.5,
    stroke: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m7.665 9.78.732-.312c-.204-.156-.324-.396-.324-.588 0-1.176 2.327-1.332 2.327-3.144 0-1.032-.887-1.86-2.351-1.86-1.14 0-2.028.48-2.604 1.224l.6.648c.444-.588 1.008-.984 1.908-.984.948 0 1.416.516 1.416 1.116 0 1.272-2.172 1.404-2.172 2.928 0 .36.144.696.468.972zm.252 2.34c.36 0 .66-.3.66-.66 0-.36-.3-.66-.66-.66-.36 0-.66.3-.66.66 0 .36.3.66.66.66z"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgQuestionCircleWhite);
var _default = exports["default"] = Memo;